import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const InboxIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M10.5914 1.73053C11.9984 1.73053 13.2164 2.70842 13.5205 4.08222L14.8819 10.2329C14.9604 10.5877 15 10.95 15 11.3134V13.2486C15 14.6193 13.8888 15.7305 12.5181 15.7305H3.48193C2.1112 15.7305 1 14.6193 1 13.2486V11.3134C1 10.95 1.03962 10.5877 1.11815 10.2329L2.47949 4.08222C2.78356 2.70842 4.00156 1.73053 5.4086 1.73053H10.5914ZM10.5914 3.23053H5.4086C4.70508 3.23053 4.09608 3.71947 3.94405 4.40637L2.5827 10.557L2.548 10.7405L5.01028 10.7413C5.55851 10.7413 6.00293 11.1857 6.00293 11.7339C6.00293 12.2822 6.44735 12.7266 6.99557 12.7266H9.05948C9.6077 12.7266 10.0521 12.2822 10.0521 11.7339C10.0521 11.1857 10.4965 10.7413 11.0448 10.7413L13.4528 10.7407C13.4426 10.6792 13.4308 10.618 13.4173 10.557L12.056 4.40637C11.9039 3.71947 11.2949 3.23053 10.5914 3.23053Z"
		/>
	</svg>
))
